import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, User, FileText, Users } from "lucide-react";
import { api } from "@/lib/apiClient";

const GROUPS = [
  { key: "clienti", label: "Clienti", icon: User, to: (r) => (r.quote_id ? `/admin/preventivi/${r.quote_id}` : "/admin/preventivi"), main: (r) => r.nome, sub: (r) => r.cf || (r.quote_id ? "" : "Nessuna pratica") },
  { key: "pratiche", label: "Pratiche", icon: FileText, to: (r) => `/admin/preventivi/${r.id}`, main: (r) => r.codice || "Pratica", sub: (r) => r.stato },
  { key: "partner", label: "Partner", icon: Users, to: () => "/admin/partner", main: (r) => r.nome, sub: (r) => r.codice },
];

// Ricerca unica dell'Agenzia: clienti, pratiche e Partner.
export function AdminSearch({ mobile = false }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const ref = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return undefined; }
    const h = setTimeout(() => api.get("/admin/search", { params: { q } }).then(({ data }) => setRes(data)).catch(() => setRes(null)), 250);
    return () => clearTimeout(h);
  }, [q]);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setRes(null); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const go = (to) => { setQ(""); setRes(null); navigate(to); };
  const flat = res ? GROUPS.flatMap((g) => res[g.key].map((r) => g.to(r))) : [];
  const tid = mobile ? "admin-search-mobile" : "admin-search";
  return (
    <div ref={ref} className={mobile ? "relative lg:hidden" : "relative hidden max-w-xl flex-1 lg:block"}>
      <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && flat[0]) go(flat[0]); }}
        placeholder="Cerca cliente, pratica o Partner…" data-testid={tid}
        className="w-full rounded-full border border-transparent bg-sage py-2.5 pl-11 pr-4 text-sm text-forest outline-none transition-colors focus:border-forest/30 focus:bg-white" />
      {res && (
        <div className="absolute left-0 right-0 top-full z-50 mt-2 max-h-[70vh] overflow-y-auto rounded-2xl border bg-white p-2 shadow-2xl" data-testid={`${tid}-results`}>
          {flat.length === 0 && <div className="px-3 py-4 text-sm text-muted-foreground">Nessun risultato per «{q}».</div>}
          {GROUPS.filter((g) => res[g.key].length).map((g) => (
            <div key={g.key} className="py-1">
              <div className="px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">{g.label}</div>
              {res[g.key].map((r) => (
                <button key={r.id} onClick={() => go(g.to(r))} data-testid={`${tid}-${g.key}-${r.id}`}
                  className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm hover:bg-sage">
                  <g.icon className="h-4 w-4 shrink-0 text-forest" />
                  <span className="min-w-0 flex-1 truncate font-medium text-forest">{g.main(r)}</span>
                  <span className="shrink-0 text-xs text-muted-foreground">{g.sub(r)}</span>
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
